import React, { useState } from "react";
import { Box, Typography, TextField, Button, CircularProgress, IconButton } from "@mui/material";
import RegexUtils from "../../services/matchingUtils/regex";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

export default function RegexPatternForm({
  formData,
  onFormChange,
  onTestRegex,
  isTestingRegex,
  regexPattern
}) {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleChange = (field) => (event) => {
    onFormChange({ ...formData, [field]: event.target.value });
  };

  const handleTestRegex = async (event) => {
    if (event) {
      event.preventDefault();
    }

    const regexPattern = RegexUtils.regexBuilder({
      main_string: formData.regexMatch,
      pattern_start: formData.regexStart || undefined,
      pattern_end: formData.regexEnd || undefined,
      no_match_strings: formData.negativeTerms ? formData.negativeTerms.split(",").map(term => term.trim()) : undefined
    });

    onTestRegex(regexPattern);
  };

  return (
    <form onSubmit={handleTestRegex}>
      <Box display="flex" flexDirection="column" gap={3}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h3" gutterBottom>
            Regex Pattern Builder
          </Typography>
          <IconButton onClick={() => setIsExpanded(!isExpanded)} data-testid="toggle-regex-pattern-form">
            {isExpanded ? <ExpandLessIcon sx={{ fontSize: 36 }} /> : <ExpandMoreIcon sx={{ fontSize: 36 }} />}
          </IconButton>
        </Box>
        {isExpanded && (
          <>
            <TextField
              label="Generated Regex Pattern"
              value={regexPattern || ""}
              disabled
              fullWidth
              sx={{ mt: 2 }}
            />

            <TextField
              label="Regex start"
              value={formData.regexStart}
              onChange={handleChange("regexStart")}
              fullWidth
            />

            <TextField
              label="Regex to match"
              value={formData.regexMatch}
              onChange={handleChange("regexMatch")}
              fullWidth
              required
            />

            <TextField
              label="Regex end"
              value={formData.regexEnd}
              onChange={handleChange("regexEnd")}
              fullWidth
            />

            <TextField
              label="Negative terms (comma separated)"
              value={formData.negativeTerms}
              onChange={handleChange("negativeTerms")}
              fullWidth
              helperText="Enter terms that should exclude vendors from matching, separated by commas"
            />

            <Box display="flex" justifyContent="flex-end">
              <Button
                type="submit"
                variant="contained"
                color="secondary"
                disabled={isTestingRegex}
                sx={{ height: 56 }}
              >
                {isTestingRegex ? <CircularProgress size={24} /> : "Try this regex"}
              </Button>
            </Box>
          </>
        )}
      </Box>
    </form>
  );
}
